export default "__VITE_ASSET__CODLUCUY__"